import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCategory, getProducts, getSubCategory } from "../axios";
import { ShoppingContext } from "./shared/context/shopping-context";
import baleLogo from "../assets/img/logo/bale.png";

const Footer = () => {
  const [category, setCategory] = useState();

  const {
    setProductsBySubCategory,
    setFlashId,
    setSubCategory,
    setFlashCartModal,
    classes,
    setClasses,
    setStyles,
    setSelectTypeCategory,
    callNewCategories,
  } = useContext(ShoppingContext);
  const location = useLocation();
  const [products, setProducts] = useState();

  useEffect(() => {
    let subCategoryId = location.search.split("=")[1];
    setSelectTypeCategory(subCategoryId);
    setFlashCartModal(false);
    if (
      subCategoryId == 1 ||
      subCategoryId == 2 ||
      subCategoryId == 3 ||
      subCategoryId == 4
    ) {
      getProducts().then(({ data }) => {
        // console.log(data);
        setProducts(data);

        const filterProducts = data?.filter(
          (p) => p.categoryID == subCategoryId,
        );

        if (filterProducts) {
          filterProducts.sort(function (a, b) {
            if (a.subCategoryID < b.subCategoryID) {
              return -1;
            }
            if (a.subCategoryID > b.subCategoryID) {
              return 1;
            }
            // sub category must be equal
            return 0;
          });
        }

        setProductsBySubCategory(filterProducts);
      });

      getSubCategory(subCategoryId).then(({ data }) => {
        setSubCategory(data);
      });

      if (subCategoryId == 4) {
        setFlashId(4);
        modalVisibleOrInvisible();
      }
    }
  }, [location.search]);

  function modalVisibleOrInvisible() {
    if (classes === "modal fade") {
      setClasses("modal fade show");
      setStyles("block");
    } else {
      setClasses("modal fade");
      setStyles("none");
    }
  }

  useEffect(() => {
    getCategory().then(({ data }) => {
      setCategory(data);
    });
  }, []);

  return (
    <footer
      className="footer_widgets "
      style={{ borderTop: "1px solid rgba(0,0,0,0.1)" }}
    >
      <a
        // href="https://t.me/atropine_admin"
        href="https://ble.ir/atropine"
        target="_blank"
        title="بله"
        className="telegram-fixed"
      >
        <div className="hoverText">پشتیبانی بله</div>
        <img width={25} height={25} src={baleLogo} />
        {/* <i className="fa fa-telegram"></i> */}
      </a>

      <div className="footer_top">
        <div className="container-fluid">
          <div className="row pe-sm-5">
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center">
              <div className="widgets_container widget_menu d-flex flex-column align-align-items-end pe-0 pe-m-5">
                <h3>اطلاعات</h3>
                <div className="footer_menu d-flex gap-4 justify-content-center">
                  <ul className="p-0">
                    <li>
                      <Link to="/about" className="text-secondary">
                        درباره ما
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="text-secondary">
                        تماس با ما
                      </Link>
                    </li>

                    {category &&
                      category
                        .filter((item, index) => !item.isOlomPaye && index <= 2)
                        .map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              callNewCategories(item.id, products);
                              window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                              });
                            }}
                          >
                            <Link
                              to={
                                item.id === 10
                                  ? "/consultation?scrollPackages=73"
                                  : `/shop?catId=${item.id}`
                              }
                              className="text-secondary"
                            >
                              {item.categoryTitle}
                            </Link>
                          </li>
                        ))}
                  </ul>
                  <ul className="p-0">
                    {category &&
                      category
                        .filter((item, index) => !item.isOlomPaye && index > 2)
                        .map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              callNewCategories(item.id, products);
                              window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                              });
                            }}
                          >
                            <Link
                              to={
                                item.id === 10
                                  ? "/consultation?scrollPackages=73"
                                  : `/shop?catId=${item.id}`
                              }
                              className="text-secondary"
                            >
                              {item.categoryTitle}
                            </Link>
                          </li>
                        ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center">
              <div className="widgets_container newsletter">
                <h3>ما را دنبال کنید</h3>
                <div className="footer_social_link">
                  <ul>
                    <li>
                      <a
                        className="instagram"
                        target="_blank"
                        href="https://www.instagram.com/atropine.ir?igsh=eWFydml4Zjk5Y3Uy&utm_source=qr"
                        title="اینستاگرام"
                      >
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        className="youtube"
                        target="_blank"
                        href="https://youtube.com/@atropinegroup?si=rrHyN6h_kvt2rqLq"
                        title="یوتیوب"
                      >
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        className="telegram"
                        href="https://t.me/Atropine_group"
                        target="_blank"
                        title="تلگرام"
                      >
                        <i className="fa fa-telegram"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a
                        className="telegram"
                        href="https://t.me/Atropine_admin"
                        target="_blank"
                        title="تلگرام"
                      >
                        <i className="fa fa-telegram"></i>
                      </a>
                    </li> */}
                    <li>
                      <a
                        className="aparat w-100 d-flex gap-1 mt-2 align-items-center justify-content-center"
                        title="پشتیبانی واتساپ"
                        // href="https://wa.me/+989214104104"
                        href="https://www.aparat.com/atropine_medical_education"
                        target="_blank"
                      >
                        <span>آپارات</span>
                        {/* <i className="fa fa-whatsapp"></i> */}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 order-first pt-4">
              <div className="widgets_container">
                <h3>آتروپین</h3>
                <p className="text-justify text-secondary">
                  مجموعه آتروپین از سال ۱۳۹۷ به صورت یک نفره و توسط{" "}
                  <span>
                    <Link
                      target="_blank"
                      to={
                        "https://www.atropine.ir/blog/%D8%AF%DA%A9%D8%AA%D8%B1%20%D9%86%D8%A7%DB%8C%D8%A8%20%D8%B2%D8%A7%D8%AF%D9%87"
                      }
                    >
                      دکتر نایب زاده
                    </Link>
                  </span>{" "}
                  شروع به کار کرد. تا سال ۱۴۰۰ تعداد ۴ درسنامه تالیف و چاپ گردید
                  که با استقبال زیادی توسط دانشجویان پزشکی و داوطلبین آزمون های
                  دستیاری و پره انترنی قرار گرفت. از آن زمان به بعد گروه آتروپین
                  شروع به بزرگ شدن کرد و همکاران خوش ذوق و علاقه مند به حیطه
                  آموزش در کنار موسس و مدیر مجموعه، دکتر نایب زاده، اقدام به
                  خدمات مشاوره ای و تالیف و تدریس در زمینه دروس مختلف نمودند تا
                  آتروپین بتواند در مسیر طولانی پزشک شدن شما را بیش از پیش
                  همراهی کند.
                </p>
                <div className="post_address border-top py-3 mt-4">
                  <p>تهران. صندوق پستی 19585431</p>
                  <div className="widgets_container contact_us">
                    <div className="footer_logo">
                      <a href="">
                        <img src="assets/img/logo/logo.png" alt="" />
                      </a>
                    </div>
                    <div className="footer_logos d-flex justify-content-center align-items-center gap-4">
                      {/* <p>
                    <a
                      className="ltr-text text-secondary"
                      href="https://t.me/Atropine_admin"
                      target="_blank"
                      without
                      rel="noreferrer"
                    >
                      پشتیبانی تلگرام
                    </a>
                  </p> */}
                      {/* <p>
                    <a
                      className="ltr-text text-secondary"
                      href="https://wa.me/+989214104104"
                      target="_blank"
                      without
                      rel="noreferrer"
                    >
                      پشتیبانی واتساپ
                    </a>
                  </p> */}
                      {/* <a
                    referrerpolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=361106&Code=1ayNYH2LnBSJh3gurhuY"
                  >
                    <img
                      referrerpolicy="origin"
                      src="https://trustseal.enamad.ir/logo.aspx?id=361106&Code=1ayNYH2LnBSJh3gurhuY"
                      alt=""
                      style={{ cursor: "pointer", width: 150, height: 150 }}
                      Code="1ayNYH2LnBSJh3gurhuY"
                    />
                  </a> */}
                      <a
                        referrerpolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=361106&Code=AerYtH5SExlo4bjrQd8T"
                      >
                        <img
                          referrerpolicy="origin"
                          src="https://trustseal.enamad.ir/logo.aspx?id=361106&Code=AerYtH5SExlo4bjrQd8T"
                          alt=""
                          style={{ cursor: "pointer", width: 150, height: 150 }}
                          Code="AerYtH5SExlo4bjrQd8T"
                        />
                      </a>
                      <a
                        target="-blank"
                        href="https://www.zarinpal.com/trustPage/atropine.ir"
                        title="دروازه پرداخت معتبر"
                      >
                        <img
                          width={100}
                          src="https://cdn.zarinpal.com/badges/trustLogo/1.svg"
                          border="0"
                          alt="دروازه پرداخت معتبر"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

// <div className="footer_bottom">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-6 col-md-6">
//               {/* <div className="copyright_area"> */}
//               {/* <span>
//                     طراحی و پیاده سازی توسط
//                     <a style={{ color: "blue" }} href="https://irappco.ir/" target="_blank">
//                       {""}
//                       {" ایران اپ کو"}
//                     </a>
//                   </span> */}
//               {/* </div> */}
//             </div>
//             <div className="col-lg-6 col-md-6">
//               <div className="footer_payment text-right">
//                 <a href="#">
//                   <img src="assets/img/icon/payment.png" alt="" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

{
  /* <div className="col-lg-1 col-md-6 col-sm-6">
              <div className="widgets_container widget_menu">
                <h3>حساب کاربری</h3>
                <div className="footer_menu">
                  <ul>
                    <li>
                      <Link to="/login" className="text-secondary">
                        حساب کاربری
                      </Link>
                    </li>
                    <li>
                      <Link to="/card" className="text-secondary">
                        سبد خرید
                      </Link>
                    </li>
                    <li>
                      <Link to="/wishlist" className="text-secondary">
                        علاقه مندی ها
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */
}
